// @ts-check

import {
  AUTHENTICATION_REQUIRED,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'

/** @type {import('vue-router').RouteRecordRaw[]} */
export const accountTransactionsRoutes = [
  {
    path: '/account-transactions',
    name: 'account-transactions',
    component: () =>
      import('@/views/account-transactions/AccountTransactionIndex.vue'),
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: true,
      icon: '$swap-horizontal',
      [ROUTE_NAME]: 'account-transactions'
    }
  }
]

export default accountTransactionsRoutes
